//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            response: null,
            title: '',
            loading: true,
            show: false,
            hasComponent: false,
            url: '',
            item: ''
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        function closeFlyout(e) {
            if (!($el.$refs.flyout == e.target || $el.$refs.flyout.contains(e.target))) {
                Event.$emit('close-flyout');
            }
        }

        var $el = this;

        Event.$on('close-flyout', function () {
            _this.show = false;
            document.querySelector('.content-wrapper').removeEventListener("click", closeFlyout);
        });

        Event.$on('show-flyout', function (title, url) {
            var component = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var item = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            Object.assign(_this.$data, _this.$options.data());
            $el.show = true;
            $el.title = title;
            $el.response = null;
            $el.hasComponent = false;
            if (!component) {
                axios.get(url).then(function (response) {
                    $el.response = response.data;
                    $el.loading = false;
                }).catch(function (error) {
                    $el.response = error.response;
                    $el.loading = false;
                });
            } else {
                $el.hasComponent = component;
                $el.url = url;
                $el.loading = false;
                $el.item = item;
            }

            // bind event listener to close flyout
            setTimeout(function () {
                document.querySelector('.content-wrapper').addEventListener("click", closeFlyout);
            }, 1000);
        });
    },

    methods: {
        close: function close() {
            this.show = false;
            Event.$emit('close-flyout');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/FlyOut.vue
// module id = P79I
// module chunks = 0 1